import { childResourceForbiddenStore } from 'shared/child-resource-forbidden-store'

export function useChildResourceForbidden() {
  const activeError = childResourceForbiddenStore(state => state.activeError)
  const reset = childResourceForbiddenStore(state => state.reset)

  return { activeError, reset }
}
